/* eslint-disable @typescript-eslint/no-explicit-any */

export const generateConfigObject = (data: any) => {
  const configObject = {
    customerId: data.customerId,
    onboardingConfig: {
      document: data?.document ? { ...data.document } : undefined,
      video: {
        recording: data.recording,
      },
      signature: {
        enabled: data.signature,
        type: data.signatureType,
      },
      security: {
        previousOnboardingValidation: data.previousOnboardings,
        blacklistValidation: data.blacklistValidation,
        governmentalValidation: data.governmentalValidation,
        documentValidation: data.documentValidation,
        nfcValidation: false,
      },
      fingerPrints: {
        enabled: false,
      },
      liveness: {
        passiveLiveness: data.liveness,
      },
    },
    user: {
      email: data.email,
      tenantId: data.tenantDefault || '',
    },
  };
  return configObject;
};
